import { useState, useEffect } from "react";
import api from "../services/api";

/**
 * Hook para verificar se as reações estão habilitadas
 * Retorna: { enabled: boolean, loading: boolean }
 */
const useReactionsEnabled = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkReactionsConfig = async () => {
      try {
        setLoading(true);
        
        // Buscar configurações do sistema
        const { data: settings } = await api.get("/settings");
        
        // Verificar se a configuração de reações está ativada
        const reactionSetting = settings.find(s => s.key === "checkReaction");
        
        const isEnabled = reactionSetting && reactionSetting.value === "enabled";
        
        setEnabled(isEnabled);
      } catch (error) {
        console.error("Erro ao verificar configuração de reações:", error);
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    checkReactionsConfig();

    // Escutar mudanças de configuração via socket
    const socket = window.socketManager?.getSocket();
    if (socket) {
      socket.on("settings", (data) => {
        if (data.action === "update" && data.setting?.key === "checkReaction") {
          setEnabled(data.setting.value === "enabled");
        }
      });
    }

    return () => {
      if (socket) {
        socket.off("settings");
      }
    };
  }, []);

  return { enabled, loading };
};

export default useReactionsEnabled;
